import * as React from "react";

const SvgPerformanceStation = ({ ...props }) => (
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1309.000000pt" height="709.000000pt" viewBox="0 0 1309.000000 709.000000"
 preserveAspectRatio="xMidYMid meet"
 {...props}>

<g transform="translate(0.000000,709.000000) scale(0.100000,-0.100000)"
 fill="currentColor" stroke="currentColor" strokeWidth={30}>
<path d="M3715 5930 c-1424 -268 -2661 -502 -2748 -519 -174 -34 -240 -60
-311 -122 -52 -46 -112 -127 -101 -137 3 -4 10 0 15 8 63 112 188 200 286 201
45 0 3468 -19 3644 -21 594 -5 4590 2 4590 9 0 4 -1749 11 -3887 16 -3708 7
-4280 11 -4223 28 14 4 1213 230 2665 503 2469 465 2646 497 2738 495 63 -1
97 1 97 8 0 7 -27 11 -67 11 -38 0 -77 2 -88 4 -11 3 -1185 -215 -2610 -484z"/>
<path d="M6490 6411 c0 -5 8 -12 18 -14 9 -3 1222 -232 2694 -509 l2677 -503
-107 -6 c-59 -4 -548 -7 -1088 -8 -1071 -1 -1584 -9 -1584 -24 0 -5 120 -7
313 -3 171 3 746 6 1277 7 531 1 1034 5 1118 8 84 3 164 3 178 -1 17 -4 24 -3
21 5 -2 6 -25 17 -53 24 -27 7 -1257 241 -2734 518 -1477 278 -2695 507 -2707
510 -13 3 -23 1 -23 -4z"/>
<path d="M12020 5362 c0 -5 11 -14 25 -20 29 -14 34 2 6 18 -24 12 -31 13 -31
2z"/>
<path d="M12080 5330 c0 -5 4 -10 9 -10 6 0 36 -24 68 -54 65 -60 110 -139
111 -197 l1 -36 -402 -6 c-221 -4 -1956 -10 -3854 -14 l-3453 -6 0 20 c0 47
32 199 52 245 11 27 18 51 15 55 -14 14 -59 -111 -74 -209 l-16 -103 -1266 2
c-696 1 -1596 5 -1999 9 l-734 6 4 37 c3 20 8 44 12 54 5 9 4 17 -1 17 -13 0
-33 -45 -33 -74 0 -21 -8 -23 -152 -46 -84 -13 -157 -27 -162 -32 -6 -4 -20
-8 -33 -8 -13 0 -23 -4 -23 -9 0 -5 15 -9 33 -9 202 3 3668 -14 3714 -18 57
-5 62 -7 53 -24 -6 -10 -10 -30 -10 -44 l0 -26 -1457 1 c-802 1 -1665 5 -1918
8 -427 6 -460 7 -463 23 -2 10 6 31 17 47 31 43 25 49 -9 11 l-31 -34 2 -265
c0 -145 3 -270 6 -278 8 -20 25 -16 19 5 -3 9 -2 22 2 27 5 7 253 8 732 4 399
-4 1259 -7 1913 -8 l1187 -1 0 -31 c0 -17 5 -40 11 -51 l11 -21 -1813 7 c-998
3 -1853 7 -1900 9 -69 1 -91 6 -108 21 -30 27 -36 14 -7 -13 19 -18 54 -27
187 -48 90 -14 170 -30 176 -35 7 -6 15 -25 19 -44 3 -19 12 -38 19 -42 7 -4
21 -23 31 -43 25 -48 84 -112 134 -145 22 -15 40 -30 40 -34 0 -4 21 -13 48
-20 26 -6 56 -16 67 -20 11 -5 159 -34 330 -66 l310 -57 425 -203 c233 -112
430 -204 436 -204 16 0 591 -277 770 -371 l142 -74 -22 -40 c-18 -34 -21 -57
-21 -145 0 -97 2 -110 31 -170 36 -74 90 -136 151 -174 38 -23 56 -26 165 -31
l123 -6 33 -36 c40 -45 54 -38 15 8 -88 103 -164 239 -208 373 -23 71 -44 187
-32 176 2 -3 17 -50 33 -105 32 -118 114 -288 185 -386 60 -82 199 -209 269
-244 27 -14 50 -27 50 -30 0 -16 -132 62 -201 119 -68 57 -80 49 -14 -9 73
-63 189 -130 275 -157 88 -27 265 -33 294 -9 9 7 16 11 16 7 0 -3 12 -1 28 5
15 6 36 13 46 15 11 2 23 10 28 17 4 8 41 29 82 46 l74 33 114 -62 c132 -73
140 -77 113 -55 -11 9 -59 37 -107 63 -83 44 -86 47 -65 59 12 7 28 12 35 13
7 0 132 -66 277 -146 190 -105 262 -149 258 -160 -3 -8 0 -14 6 -14 6 0 11 6
11 13 0 22 20 -17 20 -40 0 -29 -20 -30 -27 -2 -4 12 -11 18 -20 15 -8 -3 -24
-1 -36 5 -25 11 -25 12 47 -44 16 -12 39 -33 50 -46 12 -13 33 -36 49 -52 24
-24 27 -34 27 -93 l0 -65 -72 -3 -73 -3 -3 -392 -2 -393 -268 -2 -267 -3 -3
-377 c-1 -250 1 -378 8 -378 7 0 10 126 10 368 l0 367 1650 -3 1650 -2 0 -365
c0 -237 4 -365 10 -365 11 0 15 716 4 744 -5 14 -38 16 -265 16 l-259 0 -2
393 -3 392 -67 3 -68 3 0 69 c0 39 3 71 8 71 4 1 18 3 31 4 14 1 31 11 38 21
8 11 17 19 21 19 6 0 708 393 903 506 37 21 69 46 73 54 3 9 2 13 -4 10 -6 -3
-10 -4 -10 -1 0 10 58 35 65 28 5 -4 4 -1 0 7 -6 11 -4 13 9 8 11 -5 15 -3 10
5 -5 8 -2 9 10 5 11 -5 15 -3 10 5 -5 8 -2 9 10 5 9 -4 15 -3 12 2 -17 27
1615 923 2304 1265 l345 171 115 -5 115 -5 -57 -27 c-32 -15 -58 -32 -58 -38
0 -5 34 6 75 25 42 19 103 39 137 45 33 6 68 15 77 20 17 10 276 59 340 65 21
2 58 13 84 25 46 22 162 119 153 128 -3 2 -28 -16 -55 -40 -84 -76 -118 -87
-291 -95 l-105 -4 50 31 c101 64 165 148 194 256 l11 41 97 6 c156 11 173 10
173 -10 0 -13 2 -15 9 -5 4 7 69 23 152 37 170 29 215 39 234 55 7 6 22 10 32
9 34 -6 85 36 140 115 121 172 123 228 13 391 -75 112 -86 121 -166 140 -38 9
-85 20 -104 26 -28 7 -278 49 -294 49 -3 0 -8 15 -11 33 -15 68 -59 139 -127
203 -66 62 -88 75 -88 54z m-10910 -325 c234 -3 1075 -6 1870 -7 1515 -1 2079
-7 1955 -20 -38 -4 -103 -17 -142 -28 -66 -18 -103 -20 -408 -20 -274 0 -340
3 -358 14 -19 12 -275 16 -1732 22 -940 4 -1791 10 -1890 13 l-180 6 90 16
c62 11 134 15 230 13 77 -2 331 -6 565 -9z m11260 -4 l105 -17 -105 -7 c-58
-4 -1300 -10 -2760 -13 -2220 -5 -2665 -8 -2718 -20 -48 -11 -150 -14 -413
-14 -303 0 -353 2 -374 16 -13 9 -57 22 -97 29 -64 12 14 13 622 14 2867 4
5335 16 5615 29 11 0 67 -7 125 -17z m-7150 -29 c0 -5 -57 -12 -127 -15 -71
-4 -168 -16 -218 -27 -49 -11 -98 -21 -107 -21 -9 0 -18 -7 -20 -14 -2 -9 -8
-11 -16 -6 -22 13 32 41 111 57 135 27 377 43 377 26z m500 -2 c0 -6 -87 -10
-240 -10 -153 0 -240 4 -240 10 0 6 87 10 240 10 153 0 240 -4 240 -10z m279
-12 c46 -7 81 -18 93 -30 20 -20 24 -38 7 -38 -5 0 -8 4 -5 9 13 21 -175 60
-291 61 -41 0 -63 4 -63 11 0 13 134 7 259 -13z m6618 -14 c12 -7 24 -23 28
-34 3 -11 11 -20 16 -20 12 0 11 7 -1 31 -15 28 14 25 34 -3 14 -20 23 -78 12
-78 -16 0 -36 14 -36 26 0 17 -17 19 -22 3 -4 -11 -2713 -27 -4819 -28 l-776
-1 -6 48 c-3 26 -4 48 -4 49 6 5 1831 14 3267 16 910 1 1788 4 1950 7 314 6
323 5 357 -16z m-8673 -40 c-19 -18 -34 -40 -34 -49 0 -8 -4 -15 -9 -15 -11 0
3 76 18 93 6 8 22 12 35 10 23 -5 23 -5 -10 -39z m1276 -39 l0 -75 -117 0
c-65 0 -169 -3 -230 -7 l-113 -6 0 50 c0 60 7 65 132 87 107 20 135 22 241 24
l87 2 0 -75z m500 -5 l0 -81 -62 3 -63 3 -5 51 c-8 80 -17 84 -172 84 -91 0
-138 -4 -146 -12 -7 -7 -12 -36 -12 -65 0 -29 -4 -53 -10 -53 -6 0 -10 32 -10
75 l0 75 240 0 240 0 0 -80z m289 56 c30 -8 57 -19 62 -23 4 -4 2 -32 -4 -60
l-11 -53 -158 0 -158 0 0 82 0 81 108 -6 c59 -4 131 -13 161 -21z m1015 2 c15
-56 -4 -110 -21 -60 -3 9 -20 32 -36 50 l-31 32 41 0 c34 0 42 -4 47 -22z
m-3026 -4 c-16 -8 -28 -20 -28 -26 0 -7 5 -6 15 2 8 7 15 8 15 4 0 -5 -9 -15
-21 -22 -12 -8 -18 -9 -14 -3 3 6 1 11 -4 11 -6 0 -11 -4 -11 -8 0 -5 -7 -17
-15 -28 -14 -18 -14 -17 -4 11 13 37 28 55 54 65 34 14 42 10 13 -6z m2952
-11 c35 -32 44 -75 18 -81 -11 -2 -21 5 -27 20 -5 13 -21 35 -35 49 -43 46 -4
55 44 12z m-2392 10 c83 -3 149 -10 146 -15 -7 -11 -664 -10 -664 1 0 19 258
26 518 14z m2272 -13 c0 -6 -123 -10 -350 -10 -227 0 -350 4 -350 10 0 6 123
10 350 10 227 0 350 -4 350 -10z m5908 -21 c-3 -8 -7 -3 -11 10 -4 17 -3 21 5
13 5 -5 8 -16 6 -23z m-7184 5 c3 -9 6 -42 6 -75 l0 -59 -140 0 -140 0 0 75 0
75 134 0 c113 0 135 -2 140 -16z m1358 -17 c2 -22 5 -32 12 -48 4 -9 -4 -40
-18 -74 l-26 -57 -30 25 c-16 14 -34 27 -40 29 -7 2 -2 26 15 65 l27 62 29
-15 c17 -9 29 -10 29 -4 0 6 -11 15 -25 22 -13 6 -22 15 -19 19 7 12 44 -8 46
-24z m-2887 -67 c6 -41 4 -47 -20 -68 -33 -29 -41 -22 -50 40 -6 42 -4 49 20
74 32 32 39 25 50 -46z m672 10 l-2 -60 -321 0 -322 0 -7 46 c-3 26 -9 53 -12
60 -4 12 50 14 330 14 l335 0 -1 -60z m46 54 c9 -9 -4 -35 -14 -28 -5 3 -9 12
-9 20 0 14 12 19 23 8z m1367 -9 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8
5 15 10 15 6 0 10 -7 10 -15z m720 11 c0 -2 -11 -29 -25 -60 l-25 -56 -342 0
c-266 0 -339 3 -330 12 7 7 12 23 12 38 0 14 3 35 6 48 l6 22 349 0 c192 0
349 -2 349 -4z m5994 -137 c-9 -19 -13 -16 -48 36 -29 44 -36 63 -31 83 6 24
8 23 47 -36 33 -50 39 -67 32 -83z m-10406 102 l1452 -1 0 -212 0 -211 -1847
6 c-1017 4 -1878 10 -1915 13 l-68 7 0 206 0 206 462 -6 c255 -4 1117 -7 1916
-8z m10242 -195 c0 -202 0 -204 -22 -211 -13 -4 -1275 -9 -2805 -12 l-2783 -6
0 207 0 206 923 1 c880 2 3777 13 4395 17 l292 2 0 -204z m111 106 c29 -44 49
-86 49 -103 0 -34 -97 -183 -122 -187 -17 -3 -18 11 -18 186 0 189 0 190 21
185 12 -4 42 -38 70 -81z m-8874 -229 c-1 -59 -3 -13 -3 102 0 116 2 164 3
108 2 -56 2 -151 0 -210z m838 297 c3 -5 -1 -10 -9 -10 -9 0 -16 5 -16 10 0 6
4 10 9 10 6 0 13 -4 16 -10z m1365 0 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3
6 8 10 11 10 2 0 4 -4 4 -10z m930 -195 c0 -130 -4 -205 -10 -205 -6 0 -10 75
-10 205 0 130 4 205 10 205 6 0 10 -75 10 -205z m-3085 99 c15 -83 16 -105 5
-172 -23 -136 -29 -121 -29 76 -1 105 1 192 3 192 2 0 12 -43 21 -96z m3042
-291 c-21 -21 -87 89 -102 170 -9 45 49 195 79 207 21 7 21 5 24 -183 1 -104
1 -192 -1 -194z m-2252 348 c3 -5 1 -12 -4 -15 -5 -3 -11 1 -15 9 -6 16 9 21
19 6z m1346 -14 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z
m-871 3 c0 -6 -81 -9 -227 -8 -155 1 -202 4 -148 8 138 11 375 11 375 0z m50
0 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z
m440 -4 c8 -2 -13 -4 -47 -5 -35 0 -63 2 -63 7 0 7 76 5 110 -2z m268 -3 c-42
-2 -114 -2 -160 0 -46 1 -11 3 77 3 88 0 125 -2 83 -3z m-735 -20 c-83 -2
-223 -2 -310 0 -87 1 -18 3 152 3 171 0 242 -2 158 -3z m635 0 c-87 -2 -229
-2 -315 0 -87 1 -16 3 157 3 173 0 244 -2 158 -3z m-1840 -174 l-3 -61 -26 24
c-23 21 -25 30 -23 97 2 65 5 77 26 92 l23 18 3 -54 c2 -30 2 -82 0 -116z
m1372 160 c355 0 808 3 1008 6 l362 6 0 -56 0 -55 -1360 0 -1360 0 0 55 0 56
353 -6 c193 -3 642 -6 997 -6z m1457 -31 c4 -7 8 -44 9 -81 2 -67 1 -69 -30
-88 -17 -10 -34 -19 -38 -19 -5 0 -8 52 -8 115 l0 116 29 -16 c17 -8 33 -21
38 -27z m6008 -19 c8 -46 -12 -129 -26 -108 -5 8 -6 33 -3 56 3 22 2 49 -4 59
-7 12 -6 23 1 35 14 22 23 10 32 -42z m-6187 -69 l92 0 0 -50 0 -50 -247 -1
c-220 0 -1446 0 -2200 1 l-273 0 0 50 0 50 243 2 c133 2 703 2 1267 1 564 -2
1067 -3 1118 -3z m6152 -68 c0 -7 -16 -37 -36 -67 -33 -50 -38 -53 -50 -37
-14 18 -15 14 44 105 24 36 41 36 42 -1z m-8807 -109 c-7 -40 -12 -47 -28 -45
-11 2 -25 4 -31 4 -12 1 -11 119 1 138 3 5 19 -4 36 -20 30 -27 31 -30 22 -77z
m2887 50 l23 -57 -33 -28 c-19 -15 -38 -28 -42 -28 -7 0 -45 78 -50 105 -3 11
54 61 73 64 3 1 16 -25 29 -56z m-105 -53 l23 -55 -1396 -3 c-767 -1 -1396 -1
-1398 0 -1 2 3 29 9 61 l10 57 1365 -2 1364 -3 23 -55z m5905 -18 c0 -16 -9
-37 -20 -47 -24 -22 -36 -14 -20 14 7 13 7 21 1 21 -6 0 -17 -13 -26 -30 -29
-55 -23 -55 -530 -61 -807 -9 -5060 -17 -5068 -9 -3 3 -3 26 0 51 l5 46 2787
7 c1532 4 2796 7 2808 7 12 1 24 7 27 15 10 26 36 16 36 -14z m-8743 -48 c18
7 44 -4 37 -16 -3 -5 -11 -4 -20 3 -10 8 -14 8 -14 1 0 -6 12 -18 28 -26 36
-20 19 -20 -19 0 -17 8 -37 30 -45 49 -19 46 -17 58 4 17 9 -19 21 -31 29 -28z
m3011 48 c29 -19 -35 -102 -79 -102 -25 0 -24 4 10 39 16 17 32 39 36 50 7 23
13 25 33 13z m-3027 -84 l30 -28 -30 0 c-35 0 -51 23 -50 72 0 32 1 32 10 8 6
-14 24 -37 40 -52z m3079 45 c0 -61 -9 -73 -53 -73 l-40 0 27 25 c14 13 31 36
36 50 13 33 30 32 30 -2z m-120 -2 c-12 -24 -29 -35 -38 -26 -4 3 4 15 18 25
31 24 33 24 20 1z m-80 -30 c0 -20 -209 -22 -1467 -19 -1025 2 -1305 6 -1315
16 -10 9 267 12 1385 12 833 0 1397 -4 1397 -9z m62 -47 c58 -16 279 -16 2758
-11 1800 4 2687 2 2670 -5 -14 -5 -108 -12 -210 -15 -219 -7 -9018 -10 -10589
-4 -977 4 -1093 7 -1180 22 l-96 18 240 -5 c132 -2 981 -5 1887 -7 1307 -2
1650 1 1659 11 10 9 305 12 1405 12 1259 0 1398 -2 1456 -16z m5517 2 c-12
-10 -60 -16 -54 -6 3 5 18 10 32 10 15 0 24 -2 22 -4z m-5862 -61 l5392 0 -5
-25 c-10 -42 -64 -154 -87 -179 -35 -37 -128 -96 -172 -109 -59 -16 -586 -26
-596 -11 -5 9 -23 10 -77 1 -50 -9 -566 -12 -1853 -14 -1758 -3 -2952 -1
-3079 4 -184 7 -1430 -3 -1430 -12 0 -7 219 -10 637 -10 479 0 634 -3 626 -11
-9 -9 -7 -16 10 -29 12 -9 29 -20 37 -23 21 -8 -1694 -8 -2047 0 -161 3 -290
10 -287 15 3 4 -14 17 -38 28 l-43 20 548 0 c358 0 547 3 547 10 0 7 -214 10
-622 10 -894 1 -2537 7 -2923 11 l-330 4 -59 30 c-70 34 -153 114 -181 173
-11 23 -23 42 -26 42 -4 0 -9 12 -12 28 -3 15 -9 35 -13 45 -6 18 8 18 342 10
192 -4 2775 -8 5741 -8z m-5102 -370 c147 -33 312 -58 332 -51 30 12 -4 29
-103 51 l-96 21 828 -4 c666 -4 833 -7 849 -18 11 -7 45 -20 75 -29 51 -14 32
-15 -295 -10 -192 3 -443 8 -557 11 -184 6 -208 5 -208 -9 0 -10 20 -23 50
-34 42 -16 481 -255 477 -259 -3 -3 -1547 288 -1727 325 l-145 29 205 1 c184
1 217 -2 315 -24z m22 19 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13
-5z m1979 -9 c102 -19 146 -34 138 -46 -12 -20 -303 26 -328 51 -15 15 100 12
190 -5z m2754 -7 l35 -15 -25 -14 c-18 -10 -56 -14 -130 -13 -101 1 -160 13
-160 33 0 30 212 37 280 9z m2760 12 c0 -24 -251 -70 -306 -56 -42 11 -17 25
82 46 96 20 224 26 224 10z m2039 5 c-7 -7 -290 -57 -295 -52 -4 4 38 14 181
42 73 14 122 18 114 10z m624 -20 c-62 -12 -125 -27 -140 -32 -15 -5 -50 -6
-78 -2 -27 4 -96 8 -151 8 -138 1 -69 14 -2943 -555 -514 -102 -952 -184 -973
-182 -31 2 -41 -2 -55 -22 -9 -14 -10 -19 -3 -12 30 27 38 12 17 -28 -13 -24
-29 -40 -40 -40 -10 0 -15 5 -12 10 3 6 4 10 2 10 -4 0 -19 -21 -71 -102 -10
-16 -16 -28 -13 -28 3 0 18 20 34 45 22 35 34 45 55 45 23 0 28 -5 32 -32 12
-84 59 -1108 51 -1117 -4 -3 -169 -8 -367 -10 l-361 -3 6 23 c3 13 13 67 23
119 9 56 26 113 41 138 13 23 21 42 19 42 -8 0 -71 -114 -68 -122 1 -5 -2 -8
-8 -8 -5 0 -14 -10 -20 -22 -11 -22 -10 -22 4 -4 14 17 16 17 16 4 0 -17 -29
-160 -33 -164 -1 -1 -13 -5 -26 -9 -22 -7 -23 -5 -18 21 2 16 9 44 15 62 14
43 8 41 -19 -7 -13 -24 -32 -42 -47 -46 -13 -3 -26 -5 -28 -3 -3 3 410 664
624 998 136 212 646 969 650 965 12 -11 -27 -82 -134 -241 -68 -101 -118 -181
-110 -178 7 3 57 70 110 150 53 79 100 144 105 144 16 0 101 93 101 111 0 10
-9 23 -20 29 -15 8 -247 9 -798 4 -771 -7 -777 -7 -760 13 14 15 15 22 6 31
-9 9 268 12 1212 12 1166 -1 1223 -2 1190 -18 -46 -23 -47 -38 -4 -52 62 -21
265 11 329 50 32 20 53 20 926 19 l894 0 -75 -22 c-82 -24 -96 -40 -37 -45 41
-4 284 39 357 62 35 11 117 14 375 14 l330 0 -112 -23z m-10068 5 c27 -7 27
-8 5 -8 -14 0 -36 4 -50 8 -20 6 -21 8 -5 8 11 0 34 -4 50 -8z m68 -17 c-7 -2
-19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m54 -9 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m2078 -50 c556 -4 1016 -10 1023 -13 15 -8
313 -453 307 -459 -2 -2 -115 2 -252 9 -136 6 -570 13 -963 14 l-715 3 -190
110 c-105 60 -284 162 -400 227 -115 64 -212 120 -215 122 -3 3 85 3 195 -1
110 -3 655 -9 1210 -12z m3707 -361 c-277 -409 -385 -576 -770 -1188 -198
-314 -265 -428 -266 -452 l-1 -33 -90 6 c-49 3 -143 9 -208 12 l-118 7 -179
325 c-99 179 -180 327 -180 330 0 3 53 20 118 39 189 55 671 217 752 253 126
56 202 101 252 149 40 38 48 52 48 82 0 156 -488 273 -1390 332 -129 9 -254
19 -278 23 l-42 7 -150 225 -150 225 237 6 c131 4 578 8 993 9 415 2 960 6
1210 9 250 3 456 5 458 4 2 0 -109 -167 -246 -370z m324 363 c6 -17 -21 -58
-50 -76 -18 -11 -18 -9 2 24 12 21 22 44 22 52 0 18 19 18 26 0z m3014 -76
c-219 -74 -230 -76 -230 -58 0 6 -7 19 -15 28 -14 15 3 20 198 57 116 23 221
41 232 41 11 0 -72 -31 -185 -68z m-155 -154 c-882 -446 -1662 -880 -2792
-1552 -160 -96 -298 -174 -305 -174 -21 0 -64 48 -52 59 15 14 622 373 1054
623 516 299 1095 618 1610 888 l405 212 250 83 c138 46 255 84 260 84 6 0
-188 -100 -430 -223z m-8897 123 c130 -43 242 -93 652 -294 272 -133 577 -284
678 -337 180 -93 182 -95 162 -113 -20 -18 -32 -13 -668 303 -356 177 -651
322 -654 322 -4 0 -76 33 -160 73 -84 40 -164 78 -178 84 -63 29 22 10 168
-38z m102 0 c27 -6 50 -15 50 -21 0 -9 -15 -6 -80 18 -44 16 -35 17 30 3z
m8697 -19 c6 -13 11 -26 9 -27 -1 -2 -697 -140 -1547 -308 -849 -168 -1556
-307 -1570 -310 -22 -5 -28 -2 -33 19 -3 14 -5 29 -4 33 3 9 3084 622 3113
620 11 -1 25 -13 32 -27z m-8141 -85 c320 -60 463 -91 486 -105 18 -11 30 -20
27 -20 -3 0 -226 43 -495 95 -269 52 -492 95 -496 95 -5 0 -8 5 -8 10 0 6 7
10 16 10 9 0 220 -38 470 -85z m98 -66 l480 -93 78 -45 c44 -25 90 -52 103
-59 14 -7 46 -34 73 -60 27 -26 39 -39 27 -29 -37 30 -38 19 -2 -23 19 -23 49
-68 66 -100 l32 -59 -38 -35 c-21 -20 -41 -36 -45 -36 -4 0 -175 85 -380 188
-205 104 -494 248 -643 321 -148 72 -261 130 -250 127 11 -2 236 -46 499 -97z
m7986 82 c-8 -4 -181 -95 -385 -201 -660 -344 -1495 -814 -2346 -1322 l-276
-165 -7 160 c-3 89 -18 332 -31 540 -14 209 -23 382 -21 385 5 4 3046 609
3071 611 6 0 3 -3 -5 -8z m-5965 -281 c1024 -32 1728 -103 2060 -207 152 -48
215 -92 215 -151 0 -112 -273 -233 -1075 -476 -321 -98 -564 -179 -681 -229
l-81 -34 -41 22 -42 22 103 36 c128 45 438 146 712 232 116 36 221 72 235 79
14 7 108 39 210 70 219 68 351 116 442 162 65 33 128 83 128 103 0 5 -13 20
-30 34 -69 59 -291 81 -805 80 -701 -2 -1613 -60 -2251 -143 -84 -11 -154 -20
-158 -20 -3 0 -10 19 -16 43 -30 117 -101 237 -194 327 l-47 45 73 6 c128 10
912 9 1243 -1z m-1161 -219 c-6 -6 -24 19 -24 34 1 6 7 1 15 -9 8 -11 12 -22
9 -25z m65 -155 c6 -27 10 -51 7 -54 -3 -3 -7 1 -9 9 -3 8 -15 48 -28 89 -33
103 -34 113 -6 55 13 -27 29 -72 36 -99z m3961 88 c0 -13 -31 -24 -67 -24 -20
0 -21 3 -12 24 16 34 50 49 67 28 6 -9 12 -21 12 -28z m-995 -5 c142 -12 246
-34 276 -58 18 -15 20 -21 10 -39 -26 -48 -318 -167 -681 -276 -391 -119 -990
-322 -1232 -417 -69 -28 -132 -52 -140 -53 -25 -4 -63 -18 -118 -43 -174 -79
-268 -94 -398 -61 -162 39 -326 154 -432 300 -70 96 -152 267 -185 385 -16 57
-26 105 -24 107 7 8 119 24 314 45 921 104 2097 153 2610 110z m-2979 -176
c39 -180 93 -319 167 -428 15 -21 24 -42 21 -47 -10 -16 -80 -7 -131 17 -138
63 -233 242 -220 410 8 97 25 142 71 189 l39 41 14 -33 c7 -19 25 -85 39 -149z
m3984 138 c0 -5 11 -180 25 -388 14 -208 29 -452 33 -543 l7 -165 -34 -37
c-37 -41 -71 -50 -71 -19 0 98 -46 990 -56 1093 l-6 57 34 4 c61 7 68 7 68 -2z
m-4156 -111 c-26 -102 -11 -217 43 -323 30 -60 111 -149 156 -171 l32 -16 -45
7 c-56 8 -129 52 -165 98 -14 20 -38 61 -53 93 -24 50 -27 69 -27 162 0 83 4
112 19 140 19 35 47 72 52 68 1 -2 -4 -28 -12 -58z m2567 -772 l178 -323 -177
-11 -176 -11 -22 26 c-12 14 -158 114 -323 221 -165 107 -300 198 -301 201 -1
15 627 234 639 223 2 -2 84 -149 182 -326z m2569 188 c-17 -16 -159 -94 -147
-81 8 9 148 94 157 95 2 0 -2 -6 -10 -14z m-3470 -81 c16 -8 36 -15 45 -15 8
0 73 -39 145 -86 127 -85 129 -87 136 -130 3 -23 4 -47 3 -53 -3 -8 -399 202
-498 263 -10 7 1 15 40 31 56 23 67 22 129 -10z m3310 -10 c0 -2 -10 -9 -22
-15 -22 -11 -22 -10 -4 4 21 17 26 19 26 11z m-70 -40 c0 -2 -10 -9 -22 -15
-22 -11 -22 -10 -4 4 21 17 26 19 26 11z m-2880 -159 c0 -3 -4 -8 -10 -11 -5
-3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m133 -91 c59 -38 108 -74
110 -80 3 -6 -36 -9 -108 -7 l-112 3 -7 46 c-9 65 -8 115 3 111 4 -1 56 -34
114 -73z m2101 -64 l28 -29 -55 -31 c-30 -17 -57 -31 -60 -31 -2 0 -7 10 -11
22 -4 17 4 32 31 60 21 21 38 38 38 38 1 0 14 -13 29 -29z m-987 -72 c-18 -30
-72 -23 -72 10 0 18 8 26 35 35 31 10 36 9 42 -7 4 -10 2 -27 -5 -38z m-907
-10 c0 -18 -17 -9 -40 23 l-23 32 31 -23 c18 -12 32 -27 32 -32z m-86 25 c9
-8 16 -20 16 -26 0 -6 8 -20 17 -30 16 -18 14 -19 -97 -17 -110 1 -115 2 -142
29 -52 52 -42 60 81 60 86 0 113 -3 125 -16z m1816 12 c0 -23 -25 -58 -50 -71
-26 -14 -77 -16 -364 -14 l-333 1 9 39 10 39 312 3 c171 1 335 3 364 5 28 1
52 0 52 -2z m-755 -38 c-4 -18 -9 -36 -12 -40 -6 -12 -63 -10 -63 2 0 6 3 10
8 10 4 0 15 14 24 30 9 17 24 30 33 30 13 0 15 -6 10 -32z m795 18 c0 -21 -39
-66 -57 -66 -14 0 -13 4 4 23 11 12 23 30 26 40 7 20 27 23 27 3z m-1780 -55
c12 -12 10 -11 -9 0 -14 9 -27 22 -29 30 -3 11 -1 11 10 -1 8 -8 20 -21 28
-29z m298 22 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m467
-23 c40 -4 -95 -7 -315 -8 -223 0 -377 3 -365 8 24 10 580 11 680 0z m385 -95
l0 -75 -685 0 -685 0 0 75 0 75 685 0 685 0 0 -75z m560 0 l0 -75 -270 0 -270
0 0 75 0 75 270 0 270 0 0 -75z m-1330 -485 l0 -390 -375 0 -375 0 0 390 0
390 375 0 375 0 0 -390z m1130 0 l0 -390 -555 0 -555 0 0 390 0 390 555 0 555
0 0 -390z m350 6 l0 -383 -46 -7 c-26 -3 -100 -6 -165 -6 l-119 0 0 390 0 390
165 0 165 0 0 -384z"/>
<path d="M7464 3258 c-4 -7 -14 -24 -22 -38 -14 -24 -13 -24 3 -5 20 24 37 55
31 55 -3 0 -8 -6 -12 -12z"/>
<path d="M7204 2858 c-4 -7 -14 -24 -22 -38 -14 -24 -13 -24 3 -5 20 24 37 55
31 55 -3 0 -8 -6 -12 -12z"/>
<path d="M7154 2778 c-4 -7 -14 -24 -22 -38 -14 -24 -13 -24 3 -5 20 24 37 55
31 55 -3 0 -8 -6 -12 -12z"/>
<path d="M7080 2660 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M7034 2588 c-4 -7 -14 -24 -22 -38 -14 -24 -13 -24 3 -5 20 24 37 55
31 55 -3 0 -8 -6 -12 -12z"/>
<path d="M6984 2508 c-4 -7 -14 -24 -22 -38 -14 -24 -13 -24 3 -5 20 24 37 55
31 55 -3 0 -8 -6 -12 -12z"/>
<path d="M6910 2390 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M6880 2340 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M6850 2290 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M6800 2210 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M6770 2160 c-6 -11 -8 -20 -6 -20 3 0 10 9 16 20 6 11 8 20 6 20 -3
0 -10 -9 -16 -20z"/>
<path d="M12281 4193 c0 -6 -4 -20 -7 -30 -5 -14 -4 -15 5 -7 7 7 11 20 8 30
-3 11 -5 14 -6 7z"/>
<path d="M12226 4075 c-9 -14 -13 -25 -8 -25 5 0 14 11 20 25 6 14 10 25 8 25
-2 0 -11 -11 -20 -25z"/>
<path d="M11073 3642 c-109 -52 -272 -129 -363 -171 -242 -114 -620 -305 -620
-313 0 -15 27 -8 71 16 115 64 1137 546 1158 546 5 0 13 5 16 10 20 32 -85 -4
-262 -88z"/>
<path d="M4920 2025 c0 -2 23 -16 50 -30 62 -31 65 -26 6 9 -44 26 -56 30 -56
21z"/>
<path d="M5030 1965 c0 -2 18 -14 40 -25 50 -25 53 -19 4 9 -36 22 -44 24 -44
16z"/>
<path d="M5120 1915 c0 -2 18 -14 40 -25 22 -11 40 -18 40 -15 0 2 -18 14 -40
25 -22 11 -40 18 -40 15z"/>
</g>

  </svg>
);

export default SvgPerformanceStation;
